module.exports = __webpack_public_path__ + "media/src/images/draggable-37b3f0a98bc8f62cacb116604d85fd4c.png";